import axios from 'axios'
import store from '@/store'

const instance = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 0
})
// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    // add token here
    if (store.getters.token) {
      config.headers.common['Authorization'] = 'Bearer ' + store.getters.token
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (error) {
    // Do something with response error

    // check the error code, 4** or 5**
    return Promise.reject(error)
  }
)

export default instance



// WEBPACK FOOTER //
// ./src/utils/axios.js